export const countriesSeo = [
  {
    localeCode: 'en-US',
    countryCode: 'worldwide',
    hrefLang: 'en',
  },
  {
    localeCode: 'fr-FR',
    countryCode: 'fr',
    hrefLang: 'fr-FR',
  },
  {
    localeCode: 'en-US',
    countryCode: 'be',
    hrefLang: 'en-BE',
  },
  {
    localeCode: 'es-ES',
    countryCode: 'sp',
    hrefLang: 'es-ES',
  },
  {
    localeCode: 'pt-BR',
    countryCode: 'br',
    hrefLang: 'pt-BR',
  },
  {
    localeCode: 'pt-PT',
    countryCode: 'pt',
    hrefLang: 'pt-PT',
  },
  {
    localeCode: 'en-PT',
    countryCode: 'pt',
    hrefLang: 'en',
  },
  {
    localeCode: 'en-US',
    countryCode: 'uk',
    hrefLang: 'en-GB',
  },
  {
    localeCode: 'en-US',
    countryCode: 'us',
    hrefLang: 'en-US',
  },
  {
    localeCode: 'en-US',
    countryCode: 'ca',
    hrefLang: 'en-CA',
  },
  {
    localeCode: 'fr-CA',
    countryCode: 'ca',
    hrefLang: 'fr-CA',
  },
  {
    localeCode: 'en-US',
    countryCode: 'za',
    hrefLang: 'en-ZA',
  },
  {
    localeCode: 'en-US',
    countryCode: 'il',
    hrefLang: 'en-IL',
  },
  {
    localeCode: 'es-419',
    countryCode: 'latam',
    hrefLang: 'es-419',
  },
  {
    localeCode: 'es-419',
    countryCode: 'mx',
    hrefLang: 'es-MX',
  },
  {
    localeCode: 'en-US',
    countryCode: 'sea',
    hrefLang: 'en',
  },
  {
    localeCode: 'en-US',
    countryCode: 'mea',
    hrefLang: 'en',
  },
  {
    localeCode: 'fr-FR',
    countryCode: 'mea',
    hrefLang: 'fr-FR',
  },
  {
    localeCode: 'en-US',
    countryCode: 'cn',
    hrefLang: 'en',
  },
]
